export default __webpack_public_path__ + "static/media/icon-event-cabinet.d7294c88.svg";